import { render, staticRenderFns } from "./ReSellerReclaimRequests.vue?vue&type=template&id=88c7adfa&scoped=true&"
import script from "./ReSellerReclaimRequests.vue?vue&type=script&lang=js&"
export * from "./ReSellerReclaimRequests.vue?vue&type=script&lang=js&"
import style0 from "./ReSellerReclaimRequests.vue?vue&type=style&index=0&id=88c7adfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c7adfa",
  null
  
)

export default component.exports